<template lang="html">
  <div id="service-page">

    <section class="main-section">
      <div class="container">
        <div class="row">
          <!-- <div class="col-lg-12 col-banner">
            <div class="image">
              <div class="placed-backg img-fake" v-bind:style="{ backgroundImage: 'url(public/images/pages/services/banner-3.jpg)' }"></div>
              <img src="public/images/pages/services/banner-3.jpg">
            </div>
          </div> -->

          <div class="col-lg-12 col-content">
            <div class="box-float-image f-l" style="width: 326px;">
              <img src="public/images/pages/services/inyeccion-1.jpg">
            </div>

            <h5 class="mb-2 title">¿Que es la inyección de plásticos?</h5>
            <h6 class="subtitle text-center">Inyección de plásticos</h6>

            <p>
              En ingeniería, el moldeo por inyección es un proceso semicontinuo que consiste en inyectar un polímero en estado fundido (o ahulado) en un molde cerrado a presión y frío, a través de un orificio pequeño llamado compuerta.
            </p>

            <br />
            <p>
              En ese molde el material se solidifica, comenzando a cristalizar en polímeros semicristalinos. La pieza o parte final se obtiene al abrir el molde y sacar de la cavidad la pieza moldeada.
            </p>

            <br />
            <p>
              El moldeo por inyección es una técnica muy popular para la fabricación de artículos muy diferentes. La popularidad de este método se explica con la versatilidad de piezas que pueden fabricarse, la rapidez de fabricación, el diseño escalable desde procesos de prototipos rápidos, altos niveles de producción y bajos costos, alta o baja automatización según el costo de la pieza, geometrías muy complicadas que serían imposibles por otras técnicas, las piezas moldeadas requieren muy poco o nulo acabado pues son terminadas con la rugosidad de superficie deseada, color y transparencia u opacidad, buena tolerancia dimensional de piezas moldeadas con o sin insertos y con diferentes colores.
            </p>

            <br />
            <h6 class="subtitle">El principio del moldeo</h6>
            <div class="box-float-image f-r" style="width: 560px;">
              <img src="public/images/pages/services/inyeccion-2.jpg">
            </div>
            <p>
              El moldeo por inyección es una de las tecnologías de procesamiento de plástico más famosas, ya que representa un modo relativamente simple de fabricar componentes con formas geométricas de alta complejidad. Para ello se necesita una máquina de inyección que incluya un molde. En este último, se fabrica una cavidad cuya forma y tamaño son idénticos a las de la pieza que se desea obtener. La cavidad se llena con plástico fundido, el cual se solidifica, manteniendo la forma moldeada.
            </p>

            <br />
            <h6 class="subtitle">Unidad de inyección</h6>
            <p>
              La función principal de la unidad de inyección es la de fundir, mezclar e inyectar el polímero. Para lograr esto se utilizan husillos de diferentes características según el polímero que se desea fundir. El estudio del proceso de fusión de un polímero en la unidad de inyección debe considerar tres condiciones termodinámicas:
            </p>

            <br />
            <p>
              La temperatura de procesamiento del polímero.<br />
              La capacidad calorífica del polímero Cp [cal/g °C].<br />
              El calor latente de fusión, si el polímero es semicristalino.
            </p>

            <br />
            <p>
              El proceso de fusión involucra un incremento en el calor del polímero, que resulta del aumento de temperatura y de la fricción entre el barril y el husillo. La fricción y esfuerzos cortantes son básicos para una fusión eficiente, dado que los polímeros no son buenos conductores de calor. Un incremento en temperatura disminuye la viscosidad del polímero fundido; lo mismo sucede al incrementar la velocidad de corte. Por ello ambos parámetros deben ser ajustados durante el proceso. Existen, además, metales estándares para cada polímero con el fin de evitar la corrosión o degradación. Con algunas excepciones —como el PVC—, la mayoría de los plásticos pueden utilizarse en las mismas máquinas.
            </p>

            <br />
            <p>
              La unidad de inyección es en origen una máquina de extrusión con un solo husillo, teniendo el barril calentadores y sensores para mantener una temperatura programada constante. La profundidad entre el canal y el husillo disminuye gradual (o drásticamente, en aplicaciones especiales) desde la zona de alimentación hasta la zona de dosificación. De esta manera, la presión en el barril aumenta gradualmente.El esfuerzo mecánico, de corte y la compresión añaden calor al sistema y funden el polímero más eficientemente que si hubiera únicamente calor, siendo ésta la razón fundamental por la cual se utiliza un husillo y no una autoclave para obtener el fundido.
            </p>

            <br />
            <p>
              Una diferencia sustancial con respecto al proceso de extrusión es la existencia de una parte extra llamada cámara de reserva. Es allí donde se acumula el polímero fundido para ser inyectado. Esta cámara actúa como la de un pistón; toda la unidad se comporta como el émbolo que empuja el material. Debido a esto, una parte del husillo termina por subutilizarse, por lo que se recomiendan cañones largos para procesos de mezclado eficiente. Tanto en inyección como en extrusión se deben tomar en cuenta las relaciones de PvT (Presión, volumen, temperatura), que ayudan a entender cómo se comporta un polímero al fundir.
            </p>

            <br />
            <p>
              Articulo tomado de Wikipedia® para más información del procesos de inyección de plásticos puede visitar los siguiente sitios:
            </p>
            <p>
              <a target="_blank" href="https://es.wikipedia.org/wiki/Moldeo_por_inyecci%C3%B3n">https://es.wikipedia.org/wiki/Moldeo_por_inyecci%C3%B3n</a><br />
              <a target="_blank" href="http://www.mailxmail.com/curso/vida/inyecciondeplasticos/toc.htm">http://www.mailxmail.com/curso/vida/inyecciondeplasticos/toc.htm</a><br />
              <a target="_blank" href="http://www.librosvivos.net/smtc/homeTC.asp?TemaClave=1079">http://www.librosvivos.net/smtc/homeTC.asp?TemaClave=1079</a>
            </p>

            <br />
            <p>
              Acerca de plásticos…..
            </p>
            <p>
              <a target="_blank" href="http://www.librosvivos.net/smtc/homeTC.asp?TemaClave=1079">http://www.librosvivos.net/smtc/homeTC.asp?TemaClave=1079</a><br />
              <a target="_blank" href="https://www.monografias.com/trabajos5/plasti/plasti">https://www.monografias.com/trabajos5/plasti/plasti</a><br />
              <a target="_blank" href="https://es.wikipedia.org/wiki/Pl%C3%A1stico">https://es.wikipedia.org/wiki/Pl%C3%A1stico</a>
            </p>
          </div>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
export default {
}
</script>
